// 总出水量分析
import React from "react";
import ReactDOM from "react-dom";
import ReactEcharts from "echarts-for-react";
import * as echarts from "echarts/lib/echarts";

let myChart = null;
class Charts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: this.props.data,
    };
  }

  render() {
    return <div id="charts"></div>;
  }
  UNSAFE_componentWillReceiveProps() {
    myChart = !myChart
      ? echarts.init(document.getElementById("charts"))
      : myChart;
    let list = this.props.data.map((item) => {
      return item.stationAliasName || item.stationName;
    });
    let datalist = this.props.data.map((item) => {
      return item.totalYield.toFixed(2);
    });
    let option = {
      color: ["#3398DB"],
      tooltip: {
        trigger: "axis",
        axisPointer: {
          // 坐标轴指示器，坐标轴触发有效
          type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
        },
      },
      grid: {
        left: "3%",
        right: "4%",
        bottom: "13%",
        containLabel: true,
      },
      xAxis: [
        {
          type: "category",
          data: list,
          axisTick: {
            alignWithLabel: true,
            show: false,
          },
          splitLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
        },
      ],
      dataZoom: [
        {
          type: "inside",
          start: 0,
          end: 100,
        },
        {
          start: 0,
          end: 100,
        },
      ],
      yAxis: [
        {
          type: "value",
          axisTick: {
            alignWithLabel: true,
            show: false,
          },
          axisLine: {
            show: false,
          },
          name: "吨",
        },
      ],
      series: [
        {
          name: "总出水量",
          type: "bar",
          barWidth: "28px",
          data: datalist,
        },
      ],
    };
    myChart.setOption(option);
    window.addEventListener("resize", this.resizeFn);
  }

  resizeFn() {
    myChart.resize();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resizeFn);
    myChart = null;
  }
}

export default Charts;
